import axios from 'axios';
import { API_URL } from '../config';
import * as types from '../constants/ActionTypes';

export function addExerciseToFavourite(userId, exerciseId) {
    const url = `${API_URL}/favouriteexercises/users/${userId}/exercises/${exerciseId}`;
    return {
        types: [types.ADD_EXERCISE_TO_FAVOURITE, types.ADD_EXERCISE_TO_FAVOURITE_SUCCESS, types.ADD_EXERCISE_TO_FAVOURITE_FAILURE],
        promise: axios.post(url)
    };
}

export function removeExerciseFromFavourite(userId, exerciseId) {
    const url = `${API_URL}/favouriteexercises/users/${userId}/exercises/${exerciseId}`;
    return {
        types: [types.REMOVE_EXERCISE_FROM_FAVOURITE, types.REMOVE_EXERCISE_FROM_FAVOURITE_SUCCESS, types.REMOVE_EXERCISE_FROM_FAVOURITE_FAILURE],
        promise: axios.delete(url)
    };
}

export function getFavouriteExercises(userId) {
    const url = `${API_URL}/favouriteexercises/users/${userId}`;
    return {
        types: [types.GET_FAVOURITE_EXERCISES, types.GET_FAVOURITE_EXERCISES_SUCCESS, types.GET_FAVOURITE_EXERCISES_FAILURE],
        promise: axios.get(url)
    };
}
